import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { hideWarningTopup } from "@redux"
import { Button, Modal } from "components"
import classes from "./WarningPopup.module.scss"

const WarningPopup = () => {
  const dispatch = useDispatch()

  const [t] = useTranslation()

  const { show, message } =
    useSelector(state => state.warningPopup)

  const handleOk = () => {
    dispatch(
      hideWarningTopup()
    )
  }

  return (
    <Modal show={show}>
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {message}
        </div>
        <div className={classes["footer"]}>
          <Button
            color="success"
            onClick={handleOk}
          >
            {t("تایید")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default WarningPopup